import React, { useEffect } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/LandingPage/Footer/Footer";
import CommonLayout from "../CommonLayout/CommonLayout";
import privacyData from "./privacyData";

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <main>
      <Navbar />
      <CommonLayout data={privacyData} />
      <Footer />
    </main>
  );
};

export default PrivacyPage;

// const Privacy = () => {
//   return (
//     <section className="py-6" style={{ fontFamily: "Arial" }}>
//       <div className="pb-[30px]">
//         <h1 className="text-[38px] font-semibold container uppercase">Privacy Policy</h1>
//       </div>

//       <div className="container">
//         <p className="text-sm mb-1 flex items-baseline justify-between w-full">
//           <span>
//             Welcome to our website <a href={WEB_URL} className="text-primaryHeading">{WEB_URL}</a>.
//           </span>
//           <span>
//             <strong>Last Updated On:</strong>
//             1st November, 2024
//           </span>
//         </p>
//         <p className="text-sm mb-6">
//           This Privacy Policy outlines how we handle your personal information when you purchase tokens, receive rewards, and use our services.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">1. Information We Collect</h2>
//         <p className="text-sm mb-4">
//           When you use our services to purchase tokens and earn rewards, we may collect certain personal information directly from you, including:
//         </p>

//         <ul className="list-inside list-disc space-y-2 mb-6 text-sm">
//           <li><strong>Name:</strong> Used for account identification and personalisation.</li>
//           <li><strong>Email Address:</strong> Used for sending account alerts, updates, and promotional offers.</li>
//           <li><strong>Phone Number:</strong> Used for account-related alerts via text message.</li>
//         </ul>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">2. Purpose of Data Collection</h2>
//         <p className="text-sm mb-4">
//           We use the collected information to provide, maintain, and improve our services. Specifically, we may use your information for:
//         </p>
//         <ul className="list-inside list-disc space-y-2 mb-6 text-sm">
//           <li>Facilitating token purchases and managing your rewards program.</li>
//           <li>Sending account-related alerts, updates, and notifications via text messages and emails.</li>
//           <li>Providing customer support and responding to your inquiries.</li>
//           <li>Conducting research and analysis to improve the user experience.</li>
//           <li>Complying with legal obligations and preventing fraudulent activity.</li>
//         </ul>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">3. Consent for Communications</h2>
//         <p className="text-sm mb-4">
//           By providing your contact information, you consent to receive account-related alerts and updates through text messages and emails. You can manage your communication preferences in your account settings, and you may opt out of non-essential communications at any time.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">4. Sharing of Information with Third Parties</h2>
//         <p className="text-sm mb-4">
//           We do not sell, rent, or share your personal information with third parties for their marketing purposes. However, we may share your data with trusted third-party service providers who assist us with:
//         </p>
//         <ul className="list-inside list-disc space-y-2 mb-6 text-sm">
//           <li>Payment processing and order fulfilments.</li>
//           <li>Email and text message communication services.</li>
//           <li>Data analysis and research to improve our services.</li>
//         </ul>
//         <p className="text-sm mb-6">
//           These third parties are bound by confidentiality agreements and are only permitted to use your information for the purposes outlined in this Privacy Policy.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">5. Data Security</h2>
//         <p className="text-sm mb-4">
//           We employ industry-standard security measures to protect your personal information from unauthorised access, disclosure, or misuse. While we strive to protect your data, no security measure is infallible, and we cannot guarantee absolute security.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">6. Data Retention</h2>
//         <p className="text-sm mb-4">
//           We retain your personal information only as long as necessary to fulfil the purposes outlined in this Privacy Policy or as required by law. If you choose to close your account, we will delete or anonymise your data, except as necessary to comply with legal obligations.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">7. Changes to This Privacy Policy</h2>
//         <p className="text-sm mb-4">
//           We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. We encourage you to review this Privacy Policy regularly to stay informed about how we are protecting your information. Any changes will be posted on this page with an updated effective date.
//         </p>

//         <h2 className="text-2xl font-semibold mb-4 uppercase">8. Contact Us</h2>
//         <p className="text-sm mb-4">If you have any questions about this Privacy Policy, you can contact us:</p>
//         <ul className="list-inside list-disc space-y-2 text-sm mb-6">
//           <li>By emailing us at <a href="mailto:${Mail}" target="_blank" class="text-primaryHeading">${Mail}</a></li>
//           <li>By calling us at <a href="tel:+${Phone}" target="_blank" class="text-primaryHeading">${Phone}</a></li>
//         </ul>
//       </div>
//     </section>
//   );
// };
